module.exports = __webpack_public_path__ + "static/img/bg.f29bcfd7.png";